// extracted by mini-css-extract-plugin
module.exports = {"modal":"AlertModal-module__modal--1XcGZ","marginBottom":"AlertModal-module__marginBottom--2lCmn","footer":"AlertModal-module__footer--13Byz"};